import { render, staticRenderFns } from "./SendpushList.vue?vue&type=template&id=242dd00f"
import script from "./SendpushList.vue?vue&type=script&lang=js"
export * from "./SendpushList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports